/*
    说明
    video组件
    nigger

    调用
    <Video v-bind:videoData="gameVideo" v-if="gameVideo"></Video>
    版本

    参数
    videoData Object ：视频信息对象

        videoData {
            cover String : 封面图
            video String : 视频连接
        }

    videoConfig Object : 视频的配置

        videoConfig {
            autoplay : true/false 播放器准备好之后，是否自动播放 【默认false】
            controls : true/false 是否拥有控制条 【默认true】,如果设为false ,那么只能通过api进行控制了。也就是说界面上不会出现任何控制按钮
            height: 视频容器的高度，字符串或数字 单位像素 比如： height:300 or height:‘300px‘
            width: 视频容器的宽度, 字符串或数字 单位像素
            loop : true/false 视频播放结束后，是否循环播放
            muted : true/false 是否静音
            poster: 播放前显示的视频画面，播放开始之后自动移除。通常传入一个URL
            preload:预加载
            auto 自动
            metadata 元数据信息 ，比如视频长度，尺寸等
            none 不预加载任何数据，直到用户开始播放才开始下载
            children: Array | Object 可选子组件 从基础的Component组件继承而来的子组件，数组中的顺序将影响组件的创建顺序哦
        }

*/

<template>
    <div :class="['video_wrap', videoData.autoSizeClass && 'video-auto-size', videoData.autoSizeBgClass && 'video-auto-size-bg']">
        <video
            v-if="videoData.video"
            id="my-player"
            ref="videoRef"
            class="video-js vjs-big-play-centered vjs-fluid"
            :poster="videoData.cover ? videoData.cover : ''"
            data-setup="{}"
            playsinline="true"
            webkit-playsinline="true"
            x-webkit-airplay="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen
            x5-video-orientation="portraint"
        >
            <source :src="videoData.video" type="video/mp4" />
        </video>

        <template v-if="videoConfig.controls">
            <!-- 遮罩层 -->
            <div class="layer" @click.stop="switchStatusFunc ? switchParentStatus() : switchStatus()">
                <img v-if="isPause" src="@/assets/images/forum/play.png" class="play_icon" />
                <img v-else src="@/assets/images/forum/pause.png" class="play_icon animate__fadeOut animate__animated" />
            </div>

            <!-- S 静音按钮 -->
            <div
                class="header_video_mute animate__fadeIn animate__animated animate__fast"
                :class="isMute ? 'icon_mute' : 'icon_un_mute'"
                @click.stop="mutedFn"
            ></div>
            <!-- S 静音按钮 -->
        </template>
    </div>
</template>

<script lang="js">

import { defineComponent, reactive, ref, toRefs, onMounted, watch, onBeforeUnmount, onDeactivated, onActivated } from "vue";

// import MyVideo from 'video.js';
// import 'video.js/dist/video-js.css';


export default defineComponent({
name: "TabBar",
components: {
    // MyVideo
},
props: [
    'videoData',
    'videoConfig',
    'switchStatusFunc',
    'playState',
],
setup(props) {

    const state = reactive({
        videoData: props.videoData,
        video:'',
        videoRef: '',
        isMute: true,
        isPause: false
    })

    onMounted(() => {
        if(props.videoData.video){
            initVideo()
        }
    })

    watch(props, () => {
        state.videoData = props.videoData
        if(props.playState === 'play'){
            videoPlay('play')
        }
        if(props.playState === 'pause'){
            videoPlay('pause')
        }
    })

    onBeforeUnmount(() => {
        state.video.dispose()
    })

    onActivated(() => {
        if(props.videoData.video){
        }

        // initVideo()
    })
    //keep-active 缓存组件特有钩子 -- 进入缓存时 -- 可理解为页面隐藏时
    onDeactivated(() => {
        // console.info('卸载video')

        // state.video.dispose();
    })



    const initVideo = () => {


       try{
            const options = {
                autoplay: true,
                muted: true,
                loop: true,
                controls: false
            };

        state.isPause = !props.videoConfig.autoplay

        state.video = window.VueVideoPlayer && window.VueVideoPlayer.videojs(state.videoRef, props.videoConfig ? props.videoConfig : options, () => {
            // MyVideo.log('Your player is ready!');
            //检测音量
            // state.video.on("volumechange",() => {
            //     // state.isMute = !state.isMute;
            // })
        });
       }catch(err){
        //    console.info(err)
       }
    }

     //静音按钮事件
    const mutedFn = () => {
        state.isMute = !state.isMute;

        state.video.muted(state.isMute);
    }

    //视频播放与暂停
    const switchStatus = () => {

        if(state.isPause){
            state.video.play()
        }else{
            state.video.pause()
        }

        state.isPause = !state.isPause
    }

    const switchParentStatus = () => {
        props.switchStatusFunc(props.videoData.indexId, state.isPause)
    }

    const videoPlay = (type) => {
        if(type == 'play'){
            state.video.play();
            state.isPause = false
        }else{
            state.video.pause();
            state.isPause = true
        }
    }

    return {
        ...toRefs(state),
        mutedFn,
        switchStatus,
        videoPlay,
        switchParentStatus,
    }
},
})
</script>

<style lang="less" scoped>
@import "./Video.less";
</style>
